var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m5.5 8 4-4v8l-4-4z","fill":"#C51A1B"}));
}

IconArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
